module.exports = __webpack_public_path__ + "img/file.9b60d138.svg";